













































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ArticleApi from '@/api/article/index'
import PicModal from '@/components/upload/picModal.vue'

@Component({
  components: {
    PicModal
  }
})
export default class EditArticleTag extends AbpBase {
  form = {
    name: null,
    pictureUrl: null,
    description: null
  }

  ruleForm = {
    pictureUrl: [{ required: true, message: '请选择标签图', trigger: 'blur' }],
    name: [
      { required: true, message: '请输入标签名称', trigger: 'blur' }
    ]
  }

  created() {
    this.getLabel()
  }

  /**
   * 获取指定文章标签
   */
  getLabel() {
    let id = this.$route.query['id']
    if (id) {
      ArticleApi.getLabel(id.toString()).then(res => {
        this.form = res.data
      })
    }
  }

  picChange(e) {
    this.form.pictureUrl = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate(valid => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        ArticleApi.createOrUpdateLabel(vm.form, id).then(res => {
          vm.$router.push({
            name: 'articleTagList'
          })
        })
      }
    })
  }
}
